$(document).ready(function () {
    const projectSlider = new Swiper('#project_slider', {
        modules: [SwiperModes.Mousewheel, SwiperModes.FreeMode],
        direction: 'vertical',
        slidesPerView: 'auto',
        freeMode: true,
        mousewheel: true,
        breakpoints: {
            576: {
                direction: 'horizontal',
            }
        },
    });

    function updateButtonVisibility() {
        const isLastSlide = projectSlider.isEnd;

        if (isLastSlide) {
            $('.js__go_to_form').hide();
        } else {
            $('.js__go_to_form').show();
        }
    }

    function updateStartButtonVisibility() {
        const currentSlide = projectSlider.activeIndex;

        if (currentSlide >= 1) {
            $('.js_slider_buttons').show()
            $('.js__start_slider').show();
            $('.js__second_slide').hide();
        } else {
            $('.js_slider_buttons').hide()
            $('.js__start_slider').hide();
            $('.js__second_slide').show();
        }
    }

    function updateStepButtonVisibility() {
        const currentSlide = projectSlider.activeIndex;
        const stepButton = $('.js__step_slider');

        if (currentSlide > 0 && currentSlide < projectSlider.slides.length - 3) {
            stepButton.show();
        } else {
            stepButton.hide();
        }
    }

    $('.js__second_slide').on('click', function () {
        projectSlider.slideTo(1, 2000);
        updateButtonVisibility();
        updateStartButtonVisibility();
        updateStepButtonVisibility();
    });

    $('.js__go_to_form').on('click', function () {
        const lastIndex = projectSlider.slides.length - 1;
        projectSlider.slideTo(lastIndex, 4000);
        updateButtonVisibility();
        updateStartButtonVisibility();
        updateStepButtonVisibility();
    });

    $('.js__start_slider').on('click', function () {
        projectSlider.slideTo(0, 4000);
        updateButtonVisibility();
        updateStartButtonVisibility();
        updateStepButtonVisibility();
    });

    $('.js__step_slider').on('click', function () {
        var nextSlide = projectSlider.slides[projectSlider.activeIndex + 1];

        if ($(nextSlide).hasClass('count_slide_wrapper')) {
            projectSlider.slideTo(projectSlider.activeIndex + 2);
        } else {
            projectSlider.slideNext();
        }
        updateStepButtonVisibility();
    });


    projectSlider.on('slideChange', function () {
        updateButtonVisibility();
        updateStartButtonVisibility();
        updateStepButtonVisibility();
    });

    projectSlider.on('init', function () {
        updateButtonVisibility();
        updateStartButtonVisibility();
        updateStepButtonVisibility();
    });

    projectSlider.on('scroll', function () {
        updateButtonVisibility();
        updateStartButtonVisibility();
        updateStepButtonVisibility();
    });

    projectSlider.on('slideChangeTransitionEnd', function () {
        updateStartButtonVisibility();
        updateStepButtonVisibility();
    });
});
